import { useAuth } from "@/contexts/AuthContext";
import ManagersPanel from "@/components/ManagersPanel";

export default function WarehouseSettings() {
  const { user } = useAuth();
  return (
    <div data-testid="wh-settings-page" className="space-y-6 max-w-3xl">
      <div>
        <div className="text-xs font-mono-tech uppercase tracking-[0.2em] text-cyan-400 mb-1">/ System</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-slate-600 dark:text-slate-400 mt-1 text-sm">Your warehouse admin profile.</p>
      </div>
      <div className="border border-slate-200 dark:border-slate-800 rounded-lg p-5 bg-slate-100/40 dark:bg-slate-900/40 space-y-3 text-sm">
        <Row label="Name" value={user?.full_name || user?.name} />
        <Row label="Email" value={user?.email} />
        <Row label="Role" value={user?.role} />
        <Row label="Warehouse" value={user?.warehouse_name} />
        <Row label="Status" value={user?.status} />
      </div>

      {user?.role === "WAREHOUSE_ADMIN" && (
        <ManagersPanel
          role="Warehouse Manager"
          apiBase="/warehouse/managers"
          testIdRoot="warehouse-manager"
        />
      )}
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between border-b border-slate-200/50 dark:border-slate-800/50 pb-2 last:border-0 last:pb-0">
      <span className="text-slate-500 text-xs font-mono-tech uppercase tracking-wider">{label}</span>
      <span>{value || "—"}</span>
    </div>
  );
}
